export default __webpack_public_path__ + "static/media/business-model-innovation.7068ef1c.svg";